import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';

/**
 * Allows you to use a ref as an effect dependency and have it react to
 * changes. Dan Abramov probably feels a disturbance in the force right now.
 */
export function useRefDep(ref) {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    lastRefValue = _React$useState2[0],
    setLastRefValue = _React$useState2[1];
  React.useEffect(function () {
    return setLastRefValue(ref.current);
  });
  return lastRefValue;
}
//# sourceMappingURL=ref-dep.js.map
